import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";

export default function FirstOptimization() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">
                First Optimization
            </h2>
            <div className="grid gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle>1. Select Products</CardTitle>
                        <CardDescription>
                            Choosing products to optimize
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Visit the products page and select the items you
                            want to optimize. We recommend starting with a few
                            products to get familiar with the process.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Best practices:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Start with 3 - 5 products</li>
                                <li>
                                    Choose products with reasonable sales volume
                                    (50 - 100+ product page visits per day)
                                </li>
                                <li>
                                    Avoid seasonal or promotional items when
                                    first starting out
                                </li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>2. Configure Settings</CardTitle>
                        <CardDescription>
                            Setting up optimization parameters
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Select the items you want to optimize and click
                            "Start Optimization" to begin with default settings,
                            or use the three-dot menu to customize settings like
                            product cost, markup, price limits, and optimization
                            frequency.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Key settings to consider:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>
                                    <b>Product cost:</b> Your base cost for the
                                    product, this will be pulled from the "Unit
                                    cost" field in the product edit page in
                                    Shopify if available
                                </li>
                                <li>
                                    <b>Price limits:</b> Minimum and maximum
                                    price constraints, these are the lowest and
                                    highest prices you're willing to set for the
                                    product.
                                </li>
                                <li>
                                    <b>Optimization frequency:</b> How often
                                    prices should be updated, this is the
                                    minimum number of days between price
                                    updates. The algorithm may update the price
                                    less frequently depending on visitor
                                    numbers.
                                </li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>3. Monitor Results</CardTitle>
                        <CardDescription>
                            Tracking optimization performance
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            After starting optimization you can monitor the
                            results in the dashboard. This will show you the
                            price changes, profit changes, and conversion rate
                            changes.
                        </p>
                        <p className="text-sm text-muted-foreground">
                            This can take anywhere between a few days and a
                            couple of weeks before enough data are collected to
                            show meaningful results.
                        </p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
